// utils/chatHelpers.js
export function needAttention(
    history = [],
    agentControl = false,
    now = Date.now()
) {
    if (!history.length) return false;

    const last = history.at(-1);

    /* ───── Regla nueva SIN demora ─────
       Agente en control + último mensaje del usuario ⇒ atención inmediata
    */
    if (agentControl && last.user) return true;

    /* ───── Reglas originales ───── */
    if (!last.user) return false;                     // 1) último no es user
    if (now - last.timestamp < 300_000) return false; // 2) < 5 min ⇒ no

    // 3) busca el mensaje anterior que no sea de usuario
    for (let i = history.length - 2; i >= 0; i--) {
        const m = history[i];
        if (m.agent || m.bot) {
            // 4) si fue del bot ⇒ atención; si fue agente ⇒ no
            return !!m.bot;
        }
    }
    return false; // nunca apareció bot/agente antes
}
